module.exports = __webpack_public_path__ + "static/media/Chimera_Main.bc359560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Chimera_Main.jpg
// module id = 345
// module chunks = 0